import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api-client";

export const getAvailability = async () => {
    const res = await api.get("/Clinician/Availability");

    return res.data;
};

export const useAvailability = () => {
    return useQuery({
        queryKey: ["availability"],
        queryFn: getAvailability,
        retry: 3,
        staleTime: 1000 * 60,
    });
};
